import VCard from './vcard.js';
import VCards from './vcards.js';

import './plugin.js';

export { VCard, VCards };
